class Tabs {
  constructor(el) {
    this.el = el;
    this.buttons = Array.from(el.querySelectorAll('button[data-tab]'));
    this.tabs = Array.from(el.querySelectorAll('div[data-tab]'));

    this.activeButton = this.buttons.find(button => button.classList.contains('active'));

    this.indicator = null;

    this.addNavIndicator();
    this.attachListeners();
  }

  addNavIndicator() {
    const navContainer = this.el.querySelector('.tabs__nav');

    if (!navContainer) {
      return;
    }

    const indicator = document.createElement('div');
    indicator.classList.add('tabs__nav-indicator');
    navContainer.appendChild(indicator);
    this.indicator = indicator;

    setTimeout(this.moveIndicator.bind(this), 10);
  }

  attachListeners() {
    this.buttons.forEach(button => button.addEventListener('click', this.changeTab.bind(this)));
  }

  changeTab(event) {
    const tabName = event.currentTarget.dataset.tab;

    this.buttons.forEach(button => {
      if (button === event.currentTarget) {
        button.classList.add('active');
        this.activeButton = button;
      } else {
        button.classList.remove('active');
      }
    });

    this.tabs.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    this.moveIndicator();
  }

  moveIndicator() {
    if (!this.indicator || !this.activeButton) {
      return;
    }

    this.indicator.classList.add('active');
    this.indicator.style.left = `${this.activeButton.offsetLeft}px`;
    this.indicator.style.width = `${this.activeButton.offsetWidth}px`;
  }
}

export default Tabs;
